import { render, staticRenderFns } from "./EditDetailsWindow.vue?vue&type=template&id=2a065d84&"
import script from "./EditDetailsWindow.vue?vue&type=script&lang=js&"
export * from "./EditDetailsWindow.vue?vue&type=script&lang=js&"
import style0 from "./EditDetailsWindow.vue?vue&type=style&index=0&id=2a065d84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports